export default function () {
  return {
    coupon: {
      code: '',
      type: 0,
      enabled: true,
      validFrom: null,
      validUntil: null,
      students: [],
    },
    dateBeforePicker: false,
    dateAfterPicker: false,
    filters: {
      'date[before]': '',
      'date[after]': '',
    },
    chart: {
      options: {
        chart: {
          id: 'coupon-usage',
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return value.toFixed(1)
            },
          },
        },
      },
      series: [{
        name: 'Usos',
        data: [],
      }],
    },
  }
}
